
export const paymentDetailsAutoFill = ({ billing_address = {}, payments = [] }) => {
    const lastPayment = payments.findLast(
        (payment) => payment.sent_to_rivile && checkItsBankNumber(payment.client_bank_account)
    );
    console.log({ lastPayment });

    let values = {
        customer: ['firstname', 'lastname'].map(val => billing_address[val]).filter(String).join(" "),
        bank_account: ""
    }
    if (lastPayment) {
        if (!!lastPayment?.client_bank_account) {
            values.bank_account = lastPayment.client_bank_account
        }
        if (!!lastPayment?.client_name) {
            values.customer = lastPayment.client_name
        }
    }

    return values
}


const checkItsBankNumber = (string) => {
    if (typeof string !== "string") return false;
    string = string.trim();
    string = string.toUpperCase();
    if (string.length <= 19) return false;
    if (string.startsWith("LT")) return true;
    if (string.startsWith("LV")) return true;
    if (string.startsWith("EE")) return true;
    return false;
};